import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    setAdministracoesConsultaLicitacao: ['administracoes'],
    setAguardandoAberturaConsultaLicitacao: ['aguardandoAbertura'],
    setSituacaoPesquisaConsultaLicitacao: ['situacaoPesquisa'],
    setTipoCompraConsultaLicitacao: ['tipoCompra'],
    setExercicioLicitacaoConsultaLicitacao: ['exercicioLicitacao'],
    setNumeroLicitacaoConsultaLicitacao: ['numeroLicitacao'],
    setModalidadeConsultaLicitacao: ['modalidade'],
    setObjetoConsultaLicitacao: ['objeto'],
    setDataAberturaInicialConsultaLicitacao: ['dataAberturaInicial'],
    setDataAberturaFinalConsultaLicitacao: ['dataAberturaFinal'],
    setDataPublicacaoInicialConsultaLicitacao: ['dataPublicacaoInicial'],
    setDataPublicacaoFinalConsultaLicitacao: ['dataPublicacaoFinal'],
    setObjetoLicitacaoConsultaLicitacao: ['objetoLicitacao'],
    limpaFiltroConsultaLicitacao: [],
    receberFiltroConsultaLicitacao: ['filtroRecebido'],
    setStatusConsultaLicitacao: ['status'],
})

const INITIAL_STATE = {
    administracoes: [],
    aguardandoAbertura: '',
    tipoCompra: '',
    situacaoPesquisa: '',
    exercicioLicitacao: new Date().getFullYear(),
    numeroLicitacao: '',
    modalidade: [],
    objeto: '',
    dataAberturaInicial: '',
    dataAberturaFinal: '',
    dataPublicacaoInicial: '',
    dataPublicacaoFinal: '',
    objetoLicitacao: [],
    status: { label: '', value: '' },
}

const setAdministracoes = (state = INITIAL_STATE, action) => {
    return { ...state, administracoes: action.administracoes }
}

const setAguardandoAbertura = (state = INITIAL_STATE, action) => {
    return { ...state, aguardandoAbertura: action.aguardandoAbertura }
}

const setSituacaoPesquisa = (state = INITIAL_STATE, action) => {
    return { ...state, situacaoPesquisa: action.situacaoPesquisa }
}

const setTipoCompra = (state = INITIAL_STATE, action) => {
    return { ...state, tipoCompra: action.tipoCompra }
}

const setExercicioLicitacao = (state = INITIAL_STATE, action) => {
    return { ...state, exercicioLicitacao: action.exercicioLicitacao }
}

const setNumeroLicitacao = (state = INITIAL_STATE, action) => {
    return { ...state, numeroLicitacao: action.numeroLicitacao }
}

const setModalidade = (state = INITIAL_STATE, action) => {
    return { ...state, modalidade: action.modalidade }
}

const setDataAberturaInicial = (state = INITIAL_STATE, action) => {
    return { ...state, dataAberturaInicial: action.dataAberturaInicial }
}

const setDataAberturaFinal = (state = INITIAL_STATE, action) => {
    return { ...state, dataAberturaFinal: action.dataAberturaFinal }
}

const setDataPublicacaoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, dataPublicacaoInicial: action.dataPublicacaoInicial }
}

const setDataPublicacaoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, dataPublicacaoFinal: action.dataPublicacaoFinal }
}

const setObjeto = (state = INITIAL_STATE, action) => {
    return { ...state, objeto: action.objeto }
}

const setObjetoLicitacao = (state = INITIAL_STATE, action) => {
    return { ...state, objetoLicitacao: action.objetoLicitacao }
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const receberFiltro = (state = INITIAL_STATE, action) => {
    return action.filtroRecebido
}

const setStatus = (state = INITIAL_STATE, action) => {
    return { ...state, status: action.status }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_ADMINISTRACOES_CONSULTA_LICITACAO]: setAdministracoes,
    [Types.SET_AGUARDANDO_ABERTURA_CONSULTA_LICITACAO]: setAguardandoAbertura,
    [Types.SET_SITUACAO_PESQUISA_CONSULTA_LICITACAO]: setSituacaoPesquisa,
    [Types.SET_TIPO_COMPRA_CONSULTA_LICITACAO]: setTipoCompra,
    [Types.SET_EXERCICIO_LICITACAO_CONSULTA_LICITACAO]: setExercicioLicitacao,
    [Types.SET_NUMERO_LICITACAO_CONSULTA_LICITACAO]: setNumeroLicitacao,
    [Types.SET_MODALIDADE_CONSULTA_LICITACAO]: setModalidade,
    [Types.SET_OBJETO_CONSULTA_LICITACAO]: setObjeto,
    [Types.SET_DATA_ABERTURA_INICIAL_CONSULTA_LICITACAO]: setDataAberturaInicial,
    [Types.SET_DATA_ABERTURA_FINAL_CONSULTA_LICITACAO]: setDataAberturaFinal,
    [Types.SET_DATA_PUBLICACAO_INICIAL_CONSULTA_LICITACAO]: setDataPublicacaoInicial,
    [Types.SET_DATA_PUBLICACAO_FINAL_CONSULTA_LICITACAO]: setDataPublicacaoFinal,
    [Types.SET_OBJETO_LICITACAO_CONSULTA_LICITACAO]: setObjetoLicitacao,
    [Types.LIMPA_FILTRO_CONSULTA_LICITACAO]: limpaFiltro,
    [Types.RECEBER_FILTRO_CONSULTA_LICITACAO]: receberFiltro,
    [Types.SET_STATUS_CONSULTA_LICITACAO]: setStatus,
})
